import { render, staticRenderFns } from "./AddToSegment.vue?vue&type=template&id=4d96f81e&"
import script from "./AddToSegment.vue?vue&type=script&lang=js&"
export * from "./AddToSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports